import { useEffect, useState } from 'react';
import api from '../../services/api';

function toOption(item) {
  const value = String(item?.visitCode ?? item?.VisitCode ?? '').trim();
  const label = String(item?.visitName ?? item?.VisitName ?? value).trim() || value;
  return value ? { value, label } : null;
}

/** Empty selection → lane-visible codes so "All visit types" does not export the other profile lane. */
export function resolveReportVisitTypesForExport(selectedValues, allCodes) {
  if (Array.isArray(selectedValues) && selectedValues.length > 0) return selectedValues;
  if (Array.isArray(allCodes) && allCodes.length > 0) return allCodes;
  return [];
}

/**
 * Report-only: GET /Report/visit-types (project assignment + session study-design lane).
 * Does not call schedule-visit-types or project-selections.
 */
export default function useReportVisitTypeOptions(projectCode) {
  const [options, setOptions] = useState([]);
  const [codes, setCodes] = useState([]);
  const [nameByCode, setNameByCode] = useState({});

  useEffect(() => {
    let cancelled = false;
    const code = (projectCode || '').toString().trim();
    if (!code) {
      setOptions([]);
      setCodes([]);
      setNameByCode({});
      return undefined;
    }
    api.get('/Report/visit-types', { params: { projectCode: code } })
      .then((res) => {
        if (cancelled) return;
        const raw = Array.isArray(res.data) ? res.data : [];
        const next = raw.map(toOption).filter(Boolean);
        const map = {};
        next.forEach((o) => { map[o.value.toUpperCase()] = o.label; });
        setOptions(next);
        setCodes(next.map((o) => o.value));
        setNameByCode(map);
      })
      .catch(() => {
        if (!cancelled) {
          setOptions([]);
          setCodes([]);
          setNameByCode({});
        }
      });
    return () => { cancelled = true; };
  }, [projectCode]);

  return { options, codes, nameByCode };
}
